var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { useWeb3React } from "@web3-react/core";
import styled from "styled-components";
import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { WalletLinkConnector } from "@web3-react/walletlink-connector";
import { injectedConnector, getWalletConnectConnector, walletlinkConnector, } from "../../utils/connectors";
import Indicator from "../Indicator/Indicator";
import { BaseButton, BaseLink, BaseModalContentColumn, BaseText, Title, } from "../../designSystem";
import colors from "../../designSystem/colors";
import theme from "../../designSystem/theme";
import { MetamaskIcon, WalletConnectIcon, WalletLinkIcon, } from "../../assets/icons/connector";
import useTextAnimation from "../../hooks/useTextAnimation";
import BasicModal from "../Common/BasicModal";
import useConnectWalletModal from "../../hooks/useConnectWalletModal";
var ConnectorButton = styled(BaseButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  align-items: center;\n  width: 100%;\n\n  &:hover {\n    opacity: ", ";\n  }\n\n  ", "\n"], ["\n  background-color: ", ";\n  align-items: center;\n  width: 100%;\n\n  &:hover {\n    opacity: ", ";\n  }\n\n  ", "\n"])), colors.backgroundDarker, theme.hover.opacity, function (props) {
    switch (props.status) {
        case "connected":
            return "\n          border: " + theme.border.width + " " + theme.border.style + " " + colors.green + ";\n        ";
        case "neglected":
            return "\n          opacity: 0.24;\n\n          &:hover {\n            opacity: 0.24;\n          }\n        ";
        case "initializing":
            return "\n          border: " + theme.border.width + " " + theme.border.style + " " + colors.green + ";\n\n          &:hover {\n            opacity: 1;\n          }\n        ";
        default:
            return "";
    }
});
var IndicatorContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"])));
var ConnectorButtonText = styled(Title)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: 16px;\n"], ["\n  margin-left: 16px;\n"])));
var LearnMoreLink = styled(BaseLink)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  &:hover {\n    opacity: ", ";\n  }\n"], ["\n  &:hover {\n    opacity: ", ";\n  }\n"])), theme.hover.opacity);
var LearnMoreText = styled(BaseText)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-decoration: underline;\n"], ["\n  text-decoration: underline;\n"])));
var LearnMoreArrow = styled(BaseText)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  text-decoration: none;\n  margin-left: 5px;\n"], ["\n  text-decoration: none;\n  margin-left: 5px;\n"])));
var StyledWalletLinkIcon = styled(WalletLinkIcon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  path.outerBackground {\n    fill: #0000;\n  }\n"], ["\n  path.outerBackground {\n    fill: #0000;\n  }\n"])));
var WalletConnectModal = function () {
    var _a = useWeb3React(), connector = _a.connector, activateWeb3 = _a.activate, library = _a.library, account = _a.account, active = _a.active;
    var _b = useState(), connectingConnector = _b[0], setConnectingConnector = _b[1];
    var initializingText = useTextAnimation(Boolean(connectingConnector), {
        texts: [
            "INITIALIZING",
            "INITIALIZING .",
            "INITIALIZING ..",
            "INITIALIZING ...",
        ],
        interval: 250,
    });
    var _c = useConnectWalletModal(), show = _c[0], setShow = _c[1];
    var onClose = useCallback(function () {
        setShow(false);
    }, [setShow]);
    var handleConnect = useCallback(function (type) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setConnectingConnector(type);
                    if (!(active && connector instanceof WalletConnectConnector)) return [3 /*break*/, 2];
                    return [4 /*yield*/, connector.close()];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2:
                    _a = type;
                    switch (_a) {
                        case "metamask": return [3 /*break*/, 3];
                        case "walletConnect": return [3 /*break*/, 5];
                        case "walletLink": return [3 /*break*/, 7];
                    }
                    return [3 /*break*/, 9];
                case 3: return [4 /*yield*/, activateWeb3(injectedConnector)];
                case 4:
                    _b.sent();
                    return [3 /*break*/, 9];
                case 5: return [4 /*yield*/, activateWeb3(getWalletConnectConnector())];
                case 6:
                    _b.sent();
                    return [3 /*break*/, 9];
                case 7: return [4 /*yield*/, activateWeb3(walletlinkConnector)];
                case 8:
                    _b.sent();
                    _b.label = 9;
                case 9:
                    setConnectingConnector(undefined);
                    return [2 /*return*/];
            }
        });
    }); }, [activateWeb3, connector, active]);
    useEffect(function () {
        if (library && account) {
            onClose();
        }
    }, [library, account, onClose]);
    var getConnectorStatus = useCallback(function (connectorType) {
        // If connected, check if current button is connected
        if (active) {
            switch (connectorType) {
                case "metamask":
                    if (connector instanceof InjectedConnector)
                        return "connected";
                    break;
                case "walletConnect":
                    if (connector instanceof WalletConnectConnector)
                        return "connected";
                    break;
                case "walletLink":
                    if (connector instanceof WalletLinkConnector)
                        return "connected";
            }
        }
        // Check initializing status
        switch (connectingConnector) {
            case undefined:
                return "normal";
            case connectorType:
                return "initializing";
        }
        return "neglected";
    }, [active, connector, connectingConnector]);
    var renderConnectorIcon = useCallback(function (type) {
        switch (type) {
            case "metamask":
                return _jsx(MetamaskIcon, { height: 40, width: 40 }, void 0);
            case "walletConnect":
                return _jsx(WalletConnectIcon, { height: 40, width: 40 }, void 0);
            case "walletLink":
                return _jsx(StyledWalletLinkIcon, { height: 40, width: 40 }, void 0);
        }
    }, []);
    var renderConnectorButton = useCallback(function (type, title) { return (_jsxs(ConnectorButton, __assign({ role: "button", onClick: function () { return handleConnect(type); }, status: getConnectorStatus(type) }, { children: [renderConnectorIcon(type), _jsx(ConnectorButtonText, { children: connectingConnector === type ? initializingText : title }, void 0), getConnectorStatus(type) === "connected" && (_jsx(IndicatorContainer, { children: _jsx(Indicator, { connected: active }, void 0) }, void 0))] }), void 0)); }, [
        active,
        connectingConnector,
        getConnectorStatus,
        initializingText,
        renderConnectorIcon,
        handleConnect,
    ]);
    return (_jsx(BasicModal, __assign({ show: show, onClose: onClose, height: 354, maxWidth: 500 }, { children: _jsxs(_Fragment, { children: [_jsx(BaseModalContentColumn, __assign({ marginTop: 8 }, { children: _jsx(Title, { children: "CONNECT WALLET" }, void 0) }), void 0), _jsx(BaseModalContentColumn, { children: renderConnectorButton("metamask", "METAMASK") }, void 0), _jsx(BaseModalContentColumn, __assign({ marginTop: 16 }, { children: renderConnectorButton("walletConnect", "WALLET CONNECT") }), void 0), _jsx(BaseModalContentColumn, __assign({ marginTop: 16 }, { children: renderConnectorButton("walletLink", "COINBASE WALLET") }), void 0), _jsx(BaseModalContentColumn, __assign({ marginTop: 16 }, { children: _jsxs(LearnMoreLink, __assign({ to: "https://ethereum.org/en/wallets/", target: "_blank", rel: "noopener noreferrer", className: "w-100" }, { children: [_jsx(LearnMoreText, { children: "Learn more about wallets" }, void 0), _jsx(LearnMoreArrow, { children: "\u2192" }, void 0)] }), void 0) }), void 0)] }, void 0) }), void 0));
};
export default WalletConnectModal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=WalletConnectModal.js.map